// Copyright (C) 2012 Minted Inc.
// All Rights Reserved


// Object/Dictionary utility functions

// Note: Javascript doesn't have a Dictionary type, but 'Object' is a
// reserved word.

M.Dict = {};

/**
 * Converts an associative array into a multidimensional array, sorted by the
 * associative array's keys.
 *
 * @param {Object} obj A 1D array-like object {2: "a", 3: "b", 1: "c"}
 * @returns {Array} tuples An array of tuples sorted by their first index (key)
 *          e.g. [[1, "c"], [2, "a"], [3, "b"]]
 */
M.Dict.sortByKeys = function(obj) {
  var tuples = [];
  for (var key in obj) {
    tuples.push([parseInt(key), obj[key]]);
  }
  tuples.sort(function(a, b) {
    a = a[0];
    b = b[0];
    return a < b ? -1 : (a > b ? 1 : 0);
  });
  return tuples;
}

/**
 * Converts an associative array into a multidimensional array, sorted by the
 * associative array's values.
 *
 * @param {Object} obj A 1D array-like object {"a": 2, "b": 3, "c": 1}
 * @returns {Array} tuples An array of tuples sorted by their value
 *          e.g. [["c", 1], ["a", 2], ["b", 3]]
 */
M.Dict.sortByValues = function(obj) {
  var tuples = [];
  for (var key in obj) {
    tuples.push([key, obj[key]]);
  }
  tuples.sort(function(a, b) {
    a = a[1];
    b = b[1];
    return a < b ? -1 : (a > b ? 1 : 0);
  });
  return tuples;
}